import { render, staticRenderFns } from "./PubAbout.vue?vue&type=template&id=35471843&scoped=true&"
import script from "./PubAbout.vue?vue&type=script&lang=js&"
export * from "./PubAbout.vue?vue&type=script&lang=js&"
import style0 from "./PubAbout.vue?vue&type=style&index=0&id=35471843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35471843",
  null
  
)

export default component.exports